var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodiumSecondStroke({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 80 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7460 (Stroke)",
    d: "M10 5V10H5V82H75V10H70V5H10ZM80 5V82H0V5H5V0H75V5H80Z",
    fill: "url(#paint0_linear_0_34)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_34",
    x1: 10.5,
    y1: 20.5,
    x2: 64.6747,
    y2: 72.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965261,
    stopColor: "#50555D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodiumSecondStroke);
export default __webpack_public_path__ + "static/media/podium-second-stroke.63e5f7533cb59df29471c27fdb0533fa.svg";
export { ForwardRef as ReactComponent };